import moment from 'moment';
import { IMultiIcon } from './types';
import TimeFormatter from '../../../helpers/TimeFormatter';

const generateNames = (params: IMultiIcon[]) =>
    params.map((icon) => icon.label ?? icon.name).join(' ');
export default (args: any) => {
    const { params, type } = args;
    const colId = params.column.getColId();
    const node = params.node;

    const isGroupedRow = !!node?.parent?.key;
    const aggregatedCol = node.parent?.aggData?.[colId];
    let value = params.getValue?.(colId, params.data);

    if (isGroupedRow && aggregatedCol) {
        if (aggregatedCol?.type === 'count') {
            return aggregatedCol.value;
        }
        value = aggregatedCol;
    }

    if (type === 'multiIcon') {
        return Array.isArray(value)
            ? generateNames(value as IMultiIcon[])
            : value ?? '';
    }

    if (type === 'date') {
        return value ? moment(value, 'DD.MM.YYYY') : null;
    }

    if (type === 'duration') {
        return value ? TimeFormatter.formatDuration(value) : null;
    }

    return value ?? '';
};
